'use client';
import React, { useEffect, useState } from "react";
import Placeholder from "react-bootstrap/Placeholder";

const BlogsCard = ({ article, loading, onClick, imageLoading = "lazy" }) => {
  const fallbackImage = "/images/ImgPlaceholder.svg";
  const [imageSrc, setImageSrc] = useState(article?.image || fallbackImage);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [article]);

  useEffect(() => {
    setImageSrc(article?.image || fallbackImage);
    setImageLoaded(false);
  }, [article?.image]);

  if (loading) {
    return (
      <div className="blogs-card">
        <Placeholder as="div" animation="glow">
          <div className="blogs-image placeholder-img bg-secondary" style={{ height: '180px' }} />
        </Placeholder>
        <div className="blogs-content">
          <Placeholder as="p" animation="glow">
            <Placeholder xs={4} /> <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="h2" animation="glow">
            <Placeholder xs={8} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={10} /> <Placeholder xs={5} />
          </Placeholder>
        </div>
      </div>
    );
  }

  return (
    <div className="blogs-card" onClick={onClick}>
      <div className="blogs-image-wrap">
        {!imageLoaded && <div className="blogs-image-skeleton route-skeleton" />}
        <img
          src={imageSrc}
          className={`blogs-image blogs-image-media ${imageLoaded ? "is-loaded" : ""}`}
          alt={article?.title || "Blog image"}
          width={620}
          height={430}
          loading={imageLoading}
          decoding="async"
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            if (imageSrc !== fallbackImage) {
              setImageSrc(fallbackImage);
            }
            setImageLoaded(true);
          }}
        />
      </div>
      <div className="blogs-content">
        <p className="blogs-category">{article?.tag || "Other"}</p>
        <h2 className="blogs-title">{article?.title}</h2>
        <p className="blogs-date">{article?.date}</p>
        <p className="blogs-description">{article?.content?.slice(0, 160)}...</p>
        <p className="blogs-read-more">Read More</p>
      </div>
    </div>
  );
};

export default BlogsCard;
